<template>
    <v-card :color="color" elevation="0">
        <v-card-text class="d-flex align-center">
            <v-icon :color="iconColor" class="mr-4">{{ icon }}</v-icon>
            <span class="text-body-large font-weight-medium text-typography1">{{
                text
            }}</span>
        </v-card-text>
    </v-card>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps(['type', 'text'])

const color = computed(() => {
    switch (props.type) {
        case 'error':
            return '#f8e6e6'
        case 'warning':
            return '#fef4eb'
        case 'remark':
            return '#e8f5ff'
    }
})

const icon = computed(() => {
    switch (props.type) {
        case 'error':
            return 'mdi-alert-octagon'
        case 'warning':
            return 'mdi-alert'
        case 'remark':
            return 'mdi-information'
    }
})

const iconColor = computed(() => {
    switch (props.type) {
        case 'error':
            return '#ff5252'
        case 'warning':
            return '#ffc107'
        case 'remark':
            return '#2196f3'
    }
})
</script>
